<template>
  <div>
    <div class="head">
      <span class="title">{{$access.hasRole(['publishAdministrator', 'publishContentAdministrator']) && scope === 'all' ? course_type : role_course}}</span>
      <div>
      <el-button
        v-if="($access.hasRole(['publisher','publisherCourseAdministrator']) && scope === 'all') ||
          ($access.hasRole(['publishAdministrator', 'publishContentAdministrator']) && scope === 'own')"
        class="mr20 btn_custom_primary"
        @click="createCoursesVisible = true"
      >导入课程</el-button>
      <router-link :to="{
          name:'course_publisher_create_course',
      }">
        <el-button
          v-if="($access.hasRole(['publisher','publisherCourseAdministrator']) && scope === 'all') ||
          ($access.hasRole(['publishAdministrator', 'publishContentAdministrator']) && scope === 'own')"  class="head-btn btn_custom_primary">创建课程</el-button>
      </router-link>
      </div>
    </div>
    <section class="wrap">
      <el-input  @keyup.enter.native="changeRouteQuery({page:1})" clearable class="input-with-select search_input"
                 placeholder="请输入课程名/作者名" v-if="$access.hasRole(['publishAdministrator', 'publishContentAdministrator']) && scope === 'all'" v-model="searchMassage" @clear="changeRouteQuery({page:1})">
        <el-button @click="changeRouteQuery({page:1})" slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <el-input  @keyup.enter.native="changeRouteQuery({page:1})" clearable class="input-with-select search_input"
                 placeholder="请输入课程名/作者名"
                 v-if="($access.hasRole(['publisher','publisherCourseAdministrator']) && scope === 'all') || ($access.hasRole(['publishAdministrator', 'publishContentAdministrator']) && scope === 'own')"
                 v-model="searchMassage" @clear="changeRouteQuery({page:1})">
        <el-button @click="changeRouteQuery({page:1})" slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <el-tabs class="title_paging class-tabs-c" v-model="activeName" >
        <template v-if="($access.hasRole(['publisher','publisherCourseAdministrator']) && scope === 'all') ||
      ($access.hasRole(['publishAdministrator', 'publishContentAdministrator']) && scope === 'own')">
          <el-tab-pane label="未提交" name="first">
          </el-tab-pane>
          <el-tab-pane label="待审核" name="second">
          </el-tab-pane>
          <el-tab-pane label="审核通过" name="thirdly">
          </el-tab-pane>
        </template>
        <template v-if="$access.hasRole(['publishAdministrator', 'publishContentAdministrator']) && scope === 'all'">
          <el-tab-pane label="全部课程" name="fourthly">
          </el-tab-pane>
          <el-tab-pane label="出版社课程" name="fifth">
          </el-tab-pane>
          <el-tab-pane label="教师课程" name="sixth">
          </el-tab-pane>
        </template>
      </el-tabs>

      <div v-loading="pressUnpublishedList.state === 'loading'"  element-loading-text="拼命加载中">
        <el-table
          :data="pressUnpublishedList.list"
          border>
          <el-table-column width="50px" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <router-link
                :to="scope.row.share_course_total?{
                  name:'publisher_share_course',
                  params:{course_id: scope.row.id},
                  query:{check_status:scope.row.check_status}
                }:{name:'course_publisher_course_detail',params:{course_id: scope.row.id},query:{check_status:scope.row.check_status,tab_index:tab_index}}"
              >
                <img class="img_width" :src="scope.row.picture" alt="">
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="课程名称"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <router-link
                :to="scope.row.share_course_total?{
                  name:'publisher_share_course',
                  params:{course_id: scope.row.id},query:{check_status:scope.row.check_status}
                }:{name:'course_publisher_course_detail',params:{course_id: scope.row.id},query:{check_status:scope.row.check_status,tab_index:tab_index}}"
              >
                <span class="c-blue">{{scope.row.course_name}}</span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="author.name"
            label="作者"
            align="center"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <template v-if="$route.query.scope==='own'">
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              label="创建时间">
              <template slot-scope="scope">
                <span>{{scope.row.created_at|date('yyyy-MM-dd')}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-if="$route.query.scope==='all'">
            <el-table-column
              v-if="$access.hasRole('publisher')"
              align="center"
              :show-overflow-tooltip="true"
              label="创建时间">
              <template slot-scope="scope">
                <span>{{scope.row.created_at|date('yyyy-MM-dd')}}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="$access.hasRole('publisher')&&$route.query.tab_id==0"
              label="审核状态"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>{{scope.row.check_status==0 && scope.row.reply && scope.row.reply.read_at===null?'被驳回':'--'}}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="$route.query.tab_id!==5&&$access.hasRole(['publishAdministrator', 'publishContentAdministrator'])"
              prop="share_course_total"
              label="共享课程"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>{{('share_course_total' in scope.row)?scope.row.share_course_total:'--'}}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="$access.hasRole(['publishAdministrator', 'publishContentAdministrator'])"
              prop="author_name"
              label="发布时间"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>{{scope.row.published_at|date('yyyy-MM-dd')}}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="$access.hasRole(['publishAdministrator', 'publishContentAdministrator'])"
              prop="view_total"
              label="浏览量"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>

          </template>

          <el-table-column
            prop="address"
            v-if="$route.query.tab_id==1"
            align="center"
            :show-overflow-tooltip="true"
            label="提交时间">
            <template slot-scope="scope">
              <span>{{get(scope.row,'reply.created_at') | date('yyyy-MM-dd')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :show-overflow-tooltip="true"
            label="价格">
            <template slot-scope="scope">
              <span>{{scope.row| cardPrice}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            align="center"
            min-width="165px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div v-if="($route.query.tab_id==0||!$route.query.tab_id)&&(($route.query.scope==='all'&&!$access.hasRole(['publishAdministrator', 'publishContentAdministrator']))||$route.query.scope==='own')">
                <el-button :class="(get(scope.row,'reply.verify_remark') && !scope.row.reply.read_at) ? 'c-red' : ''"
                           :disabled="get(scope.row,'reply.verify_status ')=== 2 || isEmpty(scope.row.reply)"
                           type="text" size="small" @click="handleCommand({
                    type: 'feedback',
                    course_id: scope.row.id,
                    action:0,
                    reply:scope.row.reply,
                    isState:scope.row.check_status,
                    course_application_form_id:(scope.row.reply && scope.row.reply.id)
                })">提交反馈</el-button>
                <el-button type="text" size="small" @click="handleCommand({
                    type: 'submit',
                    course_id: scope.row.id,
                    action:1,
                },)">提交课程</el-button>
                <el-button type="text" size="small" @click="handleCommand({
                  type: 'jump',
                  data:['course_publisher_create_course',{course_id: scope.row.id}]
                })">编辑课程</el-button>
                <el-button type="text" size="small" @click="handleCommand({
                    type: 'delete',
                    data: {
                      course_id: scope.row.id,
                    }
              })">删除课程</el-button>
              </div>
              <el-button :disabled="get(scope.row,'reply.verify_status') === 2"
                         v-if="$route.query.tab_id==1"
                         type="text" size="small" @click="handleCommand({
                    type: 'feedback',
                    course_id: scope.row.id,
                    action:0,
                    reply:scope.row.reply,
                    isState:scope.row.check_status,
                    course_application_form_id: get(scope.row,'reply.id')
                },)">撤销</el-button>
              <div v-if="!scope.row.from &&$route.query.scope!=='own'&&$access.hasRole(['publishAdministrator', 'publishContentAdministrator'])">
                <el-button type="text" size="small" @click="handleCommand({
                    type:'compileQuestionBank',
                    action:0,
                    course_id: scope.row.id,
                    course_name:scope.row.course_name
                },)">编辑题库</el-button>
                <el-button type="text" size="small" @click="handleCommand({
                    type:'uploadPicture',
                    action:0,
                    course_id: scope.row.id,
                    course_name:scope.row.course_name,
                    credentials: scope.row.credentials
                },)">证书管理</el-button>
                <el-button type="text" size="small" @click="handleCommand({
                    type:'cancelRelease',
                    action:0,
                    course_id: scope.row.id
                },
                )">取消发布</el-button>
                <el-button type="text" size="small" @click="handleCommand({
                    type: 'buySeparate',
                    buy_separate: scope.row.buy_separate === 1 ? 0 : 1,
                    course_id: scope.row.id
                },)">{{scope.row.buy_separate === 1 ? '禁止单独购买' : '允许单独购买'}}</el-button>
              </div>

              <el-button type="text" size="small" @click="handleCommand({
                    type:'copyCourse',
                    course_id: scope.row.id,
                    course_name:scope.row.course_name
              })">复制课程</el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <el-pagination
        class="m30"
        v-if="pressUnpublishedList.state === 'loadend' || pressUnpublishedList.state === 'loaderr'"
        @size-change="changeRouteQuery({
          size: arguments[0],
          page: 1
        })"
        @current-change="changeRouteQuery({
          page: arguments[0]
        })"
        :page-sizes="[15, 30, 45, 60]"
        :current-page="paramsQuery.page"
        background
        :page-size="paramsQuery.size"
        layout="total,sizes, prev, pager, next"
        :total="pressUnpublishedList.total">
      </el-pagination>
      <!--提交反馈-->
      <el-dialog
        title="提交反馈"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <span>{{this.feedbackMassage}}</span>
        <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
      </el-dialog>

      <el-dialog title="证书管理" width="900px" :visible.sync="certificateManagementVisible">
        <certificate-management v-model="editCurrentEdit"></certificate-management>
        <span slot="footer" class="dialog-footer">
          <el-button @click="certificateManagementVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateCourseCertificate(editCurrentEdit)">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="导入课程" :visible.sync="createCoursesVisible" width="50%">
        <p>请上传Excel格式的文件，部分特殊格式请转换格式后再上传
          <a data-v-34242cba=""
             href="http://cdn.hzkybook.cn/file/课程导入模板.xls"
             target="_blank" class="c-blue">下载课程导入模版
          </a>
        </p>
        <el-upload
          action=""
          name="files[]"
          accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          class="upload-demo"
          ref="upload"
          :data="{
          _target: 'local'
        }"
          :on-success="handleCourseDesignUploadSuccess"
          :before-upload="beforeHandleCourseDesignUpload"
          :http-request="httpRequest">
          <el-button class="mt20" size="mini" type="primary" plain>导入课程</el-button>
        </el-upload>
      </el-dialog>
<!--     <data-import-process :visible.sync="progressDialogVisible" :data="progressData" @close="clearDataTime"></data-import-process>-->
    </section>
  </div>
</template>
<script>
  import {
    extend,
    isEmpty,
    keyBy,
    map,
    filter,
    get
  }  from 'lodash'
  import{
    mapGetters,
    mapActions
  } from 'vuex';
  import {
    toNumber
  } from "../../../../common/Fn";
  import certificateManagement from "./components/certificateManagement";
  import httpRequest from 'src/common/httpRequest';

  export default {
    components: {
      certificateManagement,
    },
    filters:{
      cardPrice:function(item){
        if(item.sales_mode===null){
          return '暂无价格'
        }else if(item.sales_mode.price === '0.00'){
          return '免费'
        }else{
          return item.sales_mode.price + '元'
        }
      },
    },
    data() {
      return {
        tab_index: 0 ,
        editCurrentEdit: {},
        feedbackMassage:'',//反馈信息
        dialogVisible:false,
        createCoursesVisible:false,
/*        progressDialogVisible: false,
        progressData: {},*/
        httpRequest,
      };
    },
    computed:{
      ...mapGetters({
        'pressUnpublishedList':'getPressUnpublishedList',//课程列表
      }),
      searchMassage:{
        get(){
          return this.$route.query.keywords || ''
        },
        set(val){
          let route = this.$route;
          this.$router.replace({
            name:route.name,
            params:route.params,
            query:extend({},route.query,{keywords:val})
          })
        }
      },
      certificateManagementVisible: {
        get() {
          return !!this.editCurrentEdit.course_id;
        },
        set() {
          this.editCurrentEdit = {};
        }
      },
      scope() {
        return this.$route.query.scope
      },
      course_type(){
        let id = +this.$route.query.tab_id;
        return {
          3:'全部课程',
          4:'出版社课程',
          5:'教师自建课程'
        }[id]||'全部课程';
      },
      role_course() {
        if(this.$access.hasRole(['publisher','publisherCourseAdministrator']) && this.scope === 'all') {
          return '课程管理'
        }else {
          return '我的课程'
        }
      },
      // eslint-disable-next-line vue/return-in-computed-property
      paramsQuery(){
        let route = this.$route.query;
        let id = +this.$route.query.tab_id;
        if(id<3){
          return {
            check_status:id,
            'page': toNumber(route.page, 1),
            'size': toNumber(route.size, 15),
            keywords: this.searchMassage,
            scope: this.scope
          }
        }
        if(id>2){
          let three = [{type:1,is_published:1}, {type:2,is_published:1},];
          let four =[{type:1,is_published:1}];
          let five = [{type:2,is_published:1}];
          return {
            filters: {3:three,4:four,5:five}[id],
            'page': toNumber(route.page, 1),
            'size': toNumber(route.size, 15),
            keywords: this.searchMassage,
            scope: this.scope
          }
        }
        if(!id){
          let obj ={
            'page': toNumber(route.page, 1),
            'size': toNumber(route.size, 15),
            keywords: this.searchMassage,
            scope: this.scope
          };
          if(this.$access.hasRole(['publishAdministrator', 'publishContentAdministrator']) && this.scope === 'all'){
            obj['filters'] = [{type:1,is_published:1},{type:2,is_published:1}];
          }else if(this.$access.hasRole(['publisher','publisherCourseAdministrator']) && this.scope === 'all'){
            obj['check_status'] = 0;
          }else if(this.$access.hasRole(['publishAdministrator', 'publishContentAdministrator']) && this.scope === 'own'){
            obj['check_status'] = 0;
          }
          return obj;
        }
      },
      tabName(){
        return ['first', 'second','thirdly','fourthly','fifth','sixth'];
      },
      // eslint-disable-next-line vue/return-in-computed-property
      isWhichTabs(){
        if(this.$access.hasRole(['publishAdministrator', 'publishContentAdministrator']) && this.scope === 'all'){
          return this.tabName[this.$route.query.tab_id] || 'fourthly'
        }
        if(this.$access.hasRole(['publisher','publisherCourseAdministrator']) && this.scope === 'all') {
          return this.tabName[this.$route.query.tab_id] || 'first'
        }
        if(this.$access.hasRole(['publishAdministrator', 'publishContentAdministrator']) && this.scope === 'own'){
          return this.tabName[this.$route.query.tab_id] || 'first'
        }
      },
      activeName:{
        get(){
          return this.tabName[this.$route.query.tab_id] || this.isWhichTabs;
        },
        set(value){
          if(this.$route.query.tab_id===0){
            this.tab_index = 0;
          }else{
            this.tab_index = 4;
          }
          this.changeRouteQuery({
            page:1,
            tab_id: this.tabName.indexOf(value)
          })
        }
      }
    },

    methods: {
      ...mapActions({
        'getCourseList': 'actionGetCourseList',//获取课程列表
        'cancelTheRelease':'actionCancelTheRelease', //取消课程发布
        'deleteCourse':'actionDeleteCourse',//删除课程
        'functionCourseSubmitAuditWithdraw':'actionCourseSubmitAuditWithdraw',//课程提交审核/撤销
        'dismissTheMessageBuyReadIsOk':'actionDismissTheMessageBuyReadIsOk',//驳回下消息置为已读
        'actionUpdateCourseCredentials': 'actionUpdateCourseCredentials',   // 上传证书
        'functionPublisherCopyCourse':'actionPublisherCopyCoursePortModule',//复制课程
        'courseSettingBuySeparateModel': 'actionPublisherCourseSettingBuySeparateModel',//设置课程是否可单独够买
        'courseCreatesWithExcel': 'actionPublisherCourseCreatesWithExcel',//课程导入
      }),
      isEmpty,
      get,
      handleCourseDesignUploadSuccess(data) {
        let upload_resource_id = data.list[0].id;
        this.courseCreatesWithExcel({
          import_type: 'publish_course_import',
          upload_resource_id: upload_resource_id
        }).then(() => {
          this.createCoursesVisible = false;
          this.$refs.upload.clearFiles();
          this.getList();
/*          this.progressDialogVisible = true;
          this.progressData = {
            data_import_id: response.id
          };*/
        })/*.catch(()=>{
          this.handleUploadError({});
          this.loadingState = false;
        })*/
      },
      beforeHandleCourseDesignUpload(file) {
        if(file.type.length>0){
          if (file.type.indexOf('application/vnd.ms-excel') === -1&&file.type.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') === -1) {
            this.$message.error('请选择excel文件，继续上传');
            return false;
          }
        }else{
          if(file.name.indexOf('.xls')===-1){
            this.$message.error('请选择excel文件，继续上传');
            return false;
          }
        }
        return true;
      },
      //下拉框的操作
      handleCommand(item){
        let course_name = item.course_name;
        switch (item.type) {
          //提交反馈和撤销
          case 'feedback':
            //撤销
            if(item.isState){
              this.$confirm('撤销后可继续修改课程信息跟内容，您确定要撤销吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal:false,
                type: 'warning'
              }).then(() => {
                this.functionCourseSubmitAuditWithdraw({
                  course_id:item.course_id,
                  action:item.action
                }).then(()=>{
                  this.$message.success('撤销成功');
                  this.getList();
                })
              });
            }else{
              //提交反馈
              this.dialogVisible = true;
              this.feedbackMassage = item.reply.verify_remark;
              if(item.reply && !item.reply.read_at){
                this.dismissTheMessageBuyReadIsOk({
                  course_id:item.course_id,
                  course_application_form_id:item.course_application_form_id
                }).then(()=>{
                  this.getList();
                  this.$message.success('操作成功');
                })
              }
            }
            break;
          case 'submit':
            //提交课程
            this.functionCourseSubmitAuditWithdraw({
              course_id:item.course_id,
              action:item.action
            }).then(() => {
              this.$message({
                type: 'success',
                message: '提交成功!'
              });
              this.getList();
            });
            break;
          case 'jump':
            //编辑课程
            this.$router.push({
              name: item.data[0],
              params: extend({}, {state: 1}, item.data[1]),
            });
            break;
          case 'delete':
            //删除课程
            this.$confirm('此操作将删除课程, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal:false,
              type: 'warning'
            }).then(() => {
              this.deleteCourse({course_id:item.data.course_id}).then(()=>{
                this.getList();
                this.$message.success('删除成功');
              });
            });
            break;
          case 'cancelRelease':
            //取消发布
            this.$confirm('您确定要取消发布吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal:false,
              type: 'warning'
            }).then(() => {
              this.cancelTheRelease({
                course_id:item.course_id,
                action:item.action
              }).then(()=>{
                this.getList();
                this.$message.success('取消发布成功')
              });
            });
            break;
          case 'compileQuestionBank':
            this.$router.push({
              name:'publisher_question_manage_index',
              query:{course_id:item.course_id,course_name:item.course_name},
            });
            break;
          case 'uploadPicture':
            this.editCurrentEdit = extend({
              course_id: item.course_id,
            }, keyBy(item.credentials, 'type'));
            break;
          case 'buySeparate':
            //设置是否允许单独购买
            this.courseSettingBuySeparateModel({
              course_id: item.course_id,
              buy_separate: item.buy_separate,
            }).then(() => {
              this.$message({
                type: 'success',
                message: '设置成功!'
              });
              this.getList();
            });
            break;
          case 'copyCourse':
            this.$confirm(`你确定要复制《${course_name}》么,复制生成的课程名字会有后缀标识`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal:false,
              type: 'warning'
            }).then(()=>{
              this.functionPublisherCopyCourse({course_id:item.course_id}).then(()=>{
                this.$message.success('复制成功');
                this.getList();
              })
            })
        }
      },
      // 更新证书内容
      updateCourseCertificate(item) {
        const editCurrentEdit = {
          course_id: item.course_id,
          credentials: filter(map(item, function(value, key) {
            if (isNaN(parseInt(key))) {
              return null;
            }
            return {
              file_url: value.file_url,
              type: key
            }
          }))
        };
        this.actionUpdateCourseCredentials(editCurrentEdit).then(() => {
          this.certificateManagementVisible = false;
          this.getList();
        });
      },
      //分页
      changeRouteQuery(args){
        let route = this.$route;
        this.$router.replace({
          name: route.name,
          params: route.params,
          query: extend({}, route.query, args)
        });
        this.$nextTick(()=>{
          this.getList();
        });

      },
      getList() {

        let query = this.paramsQuery;
        this.getCourseList(query);
      },

    },
    created(){
      this.getList();
    }
  }
</script>

<style lang="scss" scoped>
  .img_width {
    width: 30px;
    height: 30px;
    display: block;
  }
  .wrap{
    position: relative;
    padding-left: 50px;
    padding-right: 50px;
  }
  .head{
    height: 100px;
    width: 100%;
    margin-bottom: 26px;
    background-color: #f5f8fa;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title{
      font-size: 24px;
      color: #333333;
      margin-left: 55px;
    }
  }
  .head-btn{
    margin-right: 60px;
  }
  >>> a {
    text-decoration: none;
  }
  .search_input{
    width: 262px;
    z-index: 2;
    position: absolute;
    right:50px;
    top:-10px;
  }
  .class-tabs-c >>> .el-tabs__active-bar{
    background-color: $--system-color-primary;
  }
  .class-tabs-c >>> .el-tabs__item.is-active,.class-tabs-c >>> .el-tabs__item:hover{
    color: $--system-color-primary;
  }
  .class-tabs-c >>> .el-tabs__item.is-active,.class-tabs-c >>> .el-tabs__item{
    font-size: 18px;
  }
  >>> .el-pagination.is-background .el-pager li:not(.disabled).active{
    background: $--system-color-primary;
  }

</style>
